import isWxProgram from "@/helper/isWxProgram";
import {androidOrIos} from "@/helper/helper";
import {goMiniProgram} from "@/helper/wxprogramSDK";
import Store from '@/store'
import Router from '@/router'
export default (id) => {
    if(!!Store.state.userLevel) {
        console.log(Store.state.userLevel)
        isWxProgram().
        then( _ => { // 微信小程序环境
            const isIos = androidOrIos() === 'ios'
            if(isIos) Store.commit('showCustomDialog');
            else goMiniProgram('/pages/packagePay/main',{ pageId: id})
        }).
        catch(() => { // 公众号统一管理
            window.location.href = `/packagePay/${id}`
        })

    }
    else Store.commit('WRITELOGINSHOW', { status: true });
}